import { render } from "./TaffyBtnUpload.vue?vue&type=template&id=b4ec8fac&scoped=true"
import script from "./TaffyBtnUpload.vue?vue&type=script&lang=js"
export * from "./TaffyBtnUpload.vue?vue&type=script&lang=js"

import "./TaffyBtnUpload.vue?vue&type=style&index=0&id=b4ec8fac&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ec8fac"]])

export default __exports__